import React from 'react';

import { ExpenseStatus } from '@features/expense-tracker/constants';

export interface StatusTagProps {
  status: ExpenseStatus;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const StatusTag: React.FC<StatusTagProps> = ({
  status,
  className = '',
  size = 'md'
}) => {
  const getStatusConfig = (statusValue: ExpenseStatus) => {
    switch (statusValue) {
      case ExpenseStatus.APPROVED:
        return {
          bgColor: 'bg-green-50',
          textColor: 'text-green-700'
        };
      case ExpenseStatus.PENDING:
        return {
          bgColor: 'bg-yellowLite4',
          textColor: 'text-yellow70'
        };
      case ExpenseStatus.REJECTED:
        return {
          bgColor: 'bg-red-50',
          textColor: 'text-red-700'
        };
      default:
        return {
          bgColor: 'bg-blue-100',
          textColor: 'text-blue-800'
        };
    }
  };

  const getSizeClasses = (sizeValue: 'sm' | 'md' | 'lg') => {
    switch (sizeValue) {
      case 'sm':
        return {
          container: 'px-2 py-1 text-xs'
        };
      case 'md':
        return {
          container: 'px-3 py-1 text-sm'
        };
      case 'lg':
        return {
          container: 'px-4 py-2 text-base'
        };
      default:
        return {
          container: 'px-3 py-1.5 text-sm'
        };
    }
  };

  const config = getStatusConfig(status);
  const sizeClasses = getSizeClasses(size);

  return (
    <div
      className={`
        inline-flex items-center gap-2 rounded-full
        ${config.bgColor}
        ${config.textColor}
        ${sizeClasses.container}
        font-medium
        ${className}
      `}
    >
      <span className="capitalize">{status.toLowerCase()}</span>
    </div>
  );
};

export default StatusTag;
